import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { OrdersPage } from '@/features/service-agreements/orders-page';

/** The extension (forlængelse) service-agreement orders. The list endpoint requires `service-agreement:read`. */
export const Route = createFileRoute('/_app/service-agreement/orders/prolonging')({
  staticData: { featureKey: 'service-agreements' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-agreement:read'],
    }),
  component: () => <OrdersPage type="PROLONGING" />,
});
